{
  "v7.pilotage.calendrier.aucun_gel": "No freeze in this period.",
  "v7.pilotage.calendrier.aucune_livraison": "No delivery planned in this period.",
  "v7.pilotage.calendrier.chevauchements": "{{n}} deliveries fall during a freeze.",
  "v7.pilotage.calendrier.chevauchements_one": "{{n}} delivery falls during a freeze.",
  "v7.pilotage.calendrier.filtre_projets": "Projects shown",
  "v7.pilotage.calendrier.gels": "Freeze periods",
  "v7.pilotage.calendrier.lien_versions": "Programme versions",
  "v7.pilotage.calendrier.livraisons": "Project deliveries",
  "v7.pilotage.calendrier.mois_courant": "Current month",
  "v7.pilotage.calendrier.mois_precedent": "Previous month",
  "v7.pilotage.calendrier.mois_suivant": "Next month",
  "v7.pilotage.calendrier.pendant_un_gel": "during a freeze",
  "v7.pilotage.calendrier.titre": "Programme delivery calendar",
  "v7.pilotage.calendrier.tous_les_projets": "All visible projects",
  "v7.pilotage.calendrier.voir": "View",
  "v7.pilotage.calendrier.voir_gel": "View freeze {{gel}}",
  "v7.pilotage.calendrier.voir_livraison": "View delivery {{version}} of {{projet}}",
  "v7.pilotage.code.CONTEXTE_INCOMPLET": "The programme context is incomplete: reload the page.",
  "v7.pilotage.code.DROIT_NON_TENU": "You do not hold the right required for this action.",
  "v7.pilotage.code.GARDE_DROIT_ABSENTE": "This action is not enabled by the gateway yet.",
  "v7.pilotage.code.PROGRAMME_OBJECTIF_PARENT_EN_CYCLE": "This parent objective descends from the programme objective: linking it would create a cycle.",
  "v7.pilotage.code.PROGRAM_OBJECTIVE_CONFLICT": "The objective was changed in the meantime: reload before saving.",
  "v7.pilotage.code.PROGRAM_PILOT_REQUIRED": "You must be a programme pilot for this action.",
  "v7.pilotage.code.PROGRAM_RISK_OWNER_NOT_MEMBER": "The owner must be a member of the programme.",
  "v7.pilotage.code.SANS_SESSION": "Your session has expired: sign in again.",
  "v7.pilotage.code.VALIDATION_ERROR": "A field is missing or out of range.",
  "v7.pilotage.etat.chargement": "Loading: {{quoi}}…",
  "v7.pilotage.etat.en_cours": "Saving…",
  "v7.pilotage.etat.erreur": "{{quoi}}: the read did not complete.",
  "v7.pilotage.etat.geste_echoue": "The operation did not complete. Try again.",
  "v7.pilotage.etat.introuvable": "{{quoi}}: not found in this programme.",
  "v7.pilotage.etat.reessayer": "Retry",
  "v7.pilotage.etat.refus": "{{quoi}}: access denied for your profile.",
  "v7.pilotage.etat_gel.a_venir": "Upcoming",
  "v7.pilotage.etat_gel.actif": "Active",
  "v7.pilotage.etat_gel.annule": "Cancelled",
  "v7.pilotage.etat_gel.termine": "Ended",
  "v7.pilotage.etat_livraison.annule": "Cancelled",
  "v7.pilotage.etat_livraison.en_retard": "Late",
  "v7.pilotage.etat_livraison.prevu": "Planned",
  "v7.pilotage.etat_livraison.prevu_en_gel": "Planned during a freeze",
  "v7.pilotage.etat_livraison.realise": "Done",
  "v7.pilotage.etat_repere.atteint": "Reached",
  "v7.pilotage.etat_repere.en_retard": "Late",
  "v7.pilotage.etat_repere.non_date": "Not dated",
  "v7.pilotage.etat_repere.prevu": "Planned",
  "v7.pilotage.gel.aucun_designe": "No freeze is selected: open this page from the calendar.",
  "v7.pilotage.gel.avertissement": "A freeze warns the programme projects: it blocks no action from this screen.",
  "v7.pilotage.gel.etat": "Status",
  "v7.pilotage.gel.fenetre": "Period",
  "v7.pilotage.gel.introuvable": "This freeze does not exist or is not accessible to you.",
  "v7.pilotage.gel.libelle": "the freeze",
  "v7.pilotage.gel.motif": "Reason",
  "v7.pilotage.gel.perimetre": "Scope",
  "v7.pilotage.gel.titre": "Programme freeze period",
  "v7.pilotage.gel.tous_environnements": "All project environments",
  "v7.pilotage.gel.voir_dans_le_projet": "View the freeze in the project",
  "v7.pilotage.impact.high": "high",
  "v7.pilotage.impact.low": "low",
  "v7.pilotage.impact.medium": "medium",
  "v7.pilotage.livraison.aucune_designee": "No delivery is selected: open this page from the calendar.",
  "v7.pilotage.livraison.etat": "Status",
  "v7.pilotage.livraison.fenetre": "Window",
  "v7.pilotage.livraison.introuvable": "This delivery does not exist or is not accessible to you.",
  "v7.pilotage.livraison.libelle": "the delivery",
  "v7.pilotage.livraison.titre": "Programme delivery",
  "v7.pilotage.livraison.version": "Version",
  "v7.pilotage.livraison.voir_dans_le_projet": "View the delivery in the project",
  "v7.pilotage.objectif.aucun": "No objective is set yet.",
  "v7.pilotage.objectif.aucune_etape": "None",
  "v7.pilotage.objectif.date_cible": "Target date",
  "v7.pilotage.objectif.date_passee": "The target date cannot be in the past.",
  "v7.pilotage.objectif.enregistre": "Objective saved.",
  "v7.pilotage.objectif.enregistrer": "Save the objective",
  "v7.pilotage.objectif.etape_cible": "Target step",
  "v7.pilotage.objectif.libelle": "the objective and register",
  "v7.pilotage.objectif.modifie_par": "Last changed by {{nom}}",
  "v7.pilotage.objectif.objectif": "Objective",
  "v7.pilotage.objectif.parent": "Parent objective",
  "v7.pilotage.objectif.recharger": "Reload",
  "v7.pilotage.objectif.titre": "Programme settings — objective and register",
  "v7.pilotage.objectif.titre_section": "Programme objective",
  "v7.pilotage.objectif_element.annuler": "Cancel",
  "v7.pilotage.objectif_element.aucun_designe": "No top-level item is selected: open this dialog from the programme backlog.",
  "v7.pilotage.objectif_element.echeance": "Due date (optional)",
  "v7.pilotage.objectif_element.echeance_passee": "The due date cannot be in the past.",
  "v7.pilotage.objectif_element.enregistre": "Item objective saved.",
  "v7.pilotage.objectif_element.enregistrer": "Save",
  "v7.pilotage.objectif_element.indicateur": "Indicator (optional)",
  "v7.pilotage.objectif_element.introuvable": "This item does not exist in the programme or is not accessible to you.",
  "v7.pilotage.objectif_element.objectif": "Objective",
  "v7.pilotage.objectif_element.objectif_requis": "The objective is required.",
  "v7.pilotage.objectif_element.titre": "Set the objective of a top-level item",
  "v7.pilotage.objectif_element.titre_de": "Set the objective of item {{initiative}}",
  "v7.pilotage.onglets.configuration": "Configuration",
  "v7.pilotage.onglets.cycle_de_vie": "Programme lifecycle",
  "v7.pilotage.onglets.identite": "Identity",
  "v7.pilotage.onglets.nom": "Programme settings",
  "v7.pilotage.onglets.objectif_registre": "Objective and register",
  "v7.pilotage.progression.aucun_enfant": "No child programme is linked to this objective.",
  "v7.pilotage.progression.non_visibles": "{{n}} child programmes are not visible to you: counted without detail, excluded from the value.",
  "v7.pilotage.progression.non_visibles_one": "{{n}} child programme is not visible to you: counted without detail, excluded from the value.",
  "v7.pilotage.progression.partielle": "partial value",
  "v7.pilotage.progression.sans_mesure": "No measure: {{noms}}",
  "v7.pilotage.progression.sans_valeur": "Progress cannot be measured",
  "v7.pilotage.progression.titre": "Aggregated progress",
  "v7.pilotage.progression.valeur": "Progress: {{valeur}}%",
  "v7.pilotage.projets_non_visibles": "{{n}} programme projects are not visible to you: they are counted without detail.",
  "v7.pilotage.projets_non_visibles_one": "{{n}} programme project is not visible to you: it is counted without detail.",
  "v7.pilotage.provenance": "Source project",
  "v7.pilotage.registre.ajoute": "Item added to the register.",
  "v7.pilotage.registre.ajouter": "Add to the register",
  "v7.pilotage.registre.aucun_choisi": "Select a register item to edit it.",
  "v7.pilotage.registre.choisir": "Select {{titre}}",
  "v7.pilotage.registre.choisir_court": "Select",
  "v7.pilotage.registre.clore": "Close the item",
  "v7.pilotage.registre.clore_question": "Close this register item?",
  "v7.pilotage.registre.clos": "closed",
  "v7.pilotage.registre.confirmer_cloture": "Confirm closing",
  "v7.pilotage.registre.gravite": "Severity",
  "v7.pilotage.registre.gravite_porteur": "severity {{gravite}} · owner {{porteur}}",
  "v7.pilotage.registre.impact_note": "Impact rating (1 to 5)",
  "v7.pilotage.registre.impact_nouveau": "New item impact (1 to 5)",
  "v7.pilotage.registre.impact_residuel": "Residual impact (1 to 5)",
  "v7.pilotage.registre.modifie": "Register item updated.",
  "v7.pilotage.registre.modifier": "Edit the item",
  "v7.pilotage.registre.non_classe": "Not classified",
  "v7.pilotage.registre.non_note": "Not rated",
  "v7.pilotage.registre.nouvel_element": "New register item",
  "v7.pilotage.registre.ouvert": "open",
  "v7.pilotage.registre.parade": "Mitigation",
  "v7.pilotage.registre.porteur": "Owner",
  "v7.pilotage.registre.probabilite": "Likelihood (1 to 5)",
  "v7.pilotage.registre.probabilite_nouveau": "New item likelihood (1 to 5)",
  "v7.pilotage.registre.probabilite_residuelle": "Residual likelihood (1 to 5)",
  "v7.pilotage.registre.renoncer": "Cancel",
  "v7.pilotage.registre.roam": "ROAM classification",
  "v7.pilotage.registre.rouvrir": "Reopen the item",
  "v7.pilotage.registre.sans_porteur": "no owner",
  "v7.pilotage.registre.titre": "Risk register",
  "v7.pilotage.registre.titre_requis": "The new item title is required.",
  "v7.pilotage.registre.vide": "The register is empty.",
  "v7.pilotage.repere.aucun_designe": "No milestone is selected: open this page from the roadmap.",
  "v7.pilotage.repere.aucune_cadence": "No cadence contributes to this milestone.",
  "v7.pilotage.repere.aucune_contribution": "No project contribution.",
  "v7.pilotage.repere.aucune_version": "No version contributes to this milestone.",
  "v7.pilotage.repere.cadences": "Contributing cadences",
  "v7.pilotage.repere.contributions": "Project contributions",
  "v7.pilotage.repere.contributions_non_divulguees": "{{n}} projects contribute without being accessible to you: their contributions are not disclosed.",
  "v7.pilotage.repere.contributions_non_divulguees_one": "{{n}} project contributes without being accessible to you: its contribution is not disclosed.",
  "v7.pilotage.repere.date_prevue": "Planned date",
  "v7.pilotage.repere.date_reelle": "Actual date",
  "v7.pilotage.repere.dates": "Milestone dates",
  "v7.pilotage.repere.etat": "Status",
  "v7.pilotage.repere.intitule": "Title",
  "v7.pilotage.repere.introuvable": "This milestone does not exist or is not accessible to you.",
  "v7.pilotage.repere.libelle": "the milestone",
  "v7.pilotage.repere.lien_versions": "Programme versions",
  "v7.pilotage.repere.nature": "Kind (model)",
  "v7.pilotage.repere.non_atteint": "Not reached yet",
  "v7.pilotage.repere.non_date": "Not dated",
  "v7.pilotage.repere.pas_une_porte": "This milestone is not a model gate: no pass condition.",
  "v7.pilotage.repere.porte": "Model gate",
  "v7.pilotage.repere.retour": "Back to the roadmap",
  "v7.pilotage.repere.titre": "Programme milestone",
  "v7.pilotage.repere.versions": "Contributing versions",
  "v7.pilotage.repere.voir_element": "View the programme item",
  "v7.pilotage.retour_calendrier": "Back to the calendar",
  "v7.pilotage.roam.accepte": "Accepted",
  "v7.pilotage.roam.attenue": "Mitigated",
  "v7.pilotage.roam.possede": "Owned",
  "v7.pilotage.roam.resolu": "Resolved",
  "v7.pilotage.sans_programme": "No programme is selected: choose a programme in the context bar.",
  "v7.pilotage.scores.aucun": "No open item to score.",
  "v7.pilotage.scores.inherent": "likelihood {{p}} × impact {{i}}",
  "v7.pilotage.scores.resume": "Inherent score {{inherent}} · residual {{residuel}}",
  "v7.pilotage.scores.titre": "Inherent and residual scores",
  "v7.pilotage.vague_ulterieure": "“{{ecran}}” leads to a screen that is not available yet.",
  "v7.pilotage.version.aucune_approbation_globale": "No global approval is implied: each project keeps its own gates and approvals.",
  "v7.pilotage.version.aucune_composante": "No visible component version.",
  "v7.pilotage.version.aucune_designee": "No version is selected: open this page from the programme versions.",
  "v7.pilotage.version.aucune_livraison": "no delivery planned",
  "v7.pilotage.version.composantes": "Component project versions",
  "v7.pilotage.version.composition": "{{n}} projects make up this version",
  "v7.pilotage.version.composition_one": "{{n}} project makes up this version",
  "v7.pilotage.version.compteurs": "{{elements}} items, {{anomalies}} defects, {{revisions}} revisions",
  "v7.pilotage.version.introuvable": "This version does not exist or is not accessible to you.",
  "v7.pilotage.version.libelle": "the version",
  "v7.pilotage.version.preparation": "Readiness by environment",
  "v7.pilotage.version.production": "production",
  "v7.pilotage.version.retour": "Back to versions",
  "v7.pilotage.version.titre": "Programme version",
  "v7.pilotage.version.titre_de": "Programme version {{version}}",
  "v7.pilotage.version.voir_dans_le_projet": "View the version in the project",
  "v7.pilotage.versions.aucun_gel": "No freeze",
  "v7.pilotage.versions.aucune": "No version in the visible programme projects.",
  "v7.pilotage.versions.aucune_fenetre": "No release window",
  "v7.pilotage.versions.composee_de": "projects: {{projets}}",
  "v7.pilotage.versions.fenetre": "Release on {{date}} ({{environnement}})",
  "v7.pilotage.versions.gel_du_au": "Freeze from {{du}} to {{au}}",
  "v7.pilotage.versions.lire_projet": "read in the project",
  "v7.pilotage.versions.liste": "Aggregated project versions",
  "v7.pilotage.versions.non_agregees": "This programme's model does not group its projects' versions: read them in each project.",
  "v7.pilotage.versions.titre": "Programme versions",
  "v7.pilotage.versions.voir_version": "View version {{version}}"
}
